import { render } from "./UboPerson.vue?vue&type=template&id=16862672&scoped=true"
import script from "./UboPerson.vue?vue&type=script&lang=js"
export * from "./UboPerson.vue?vue&type=script&lang=js"

import "./custom-ubo.scss?vue&type=style&index=0&id=16862672&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16862672"]])

export default __exports__